'use client';

import React, { useEffect, useRef } from 'react';

export default function ContactSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }); },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-dark-bg noise-overlay w-full px-4 md:px-12 pt-12 md:pt-16 pb-16 md:pb-20">
      <div className="max-w-4xl mx-auto text-center">
        <div className="reveal">
          <span className="text-3xl md:text-4xl block mb-4 md:mb-5">🙏</span>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-black text-white tracking-tight mb-3 md:mb-4">
            Get in Touch
          </h2>
          <p className="text-white/60 text-sm md:text-base mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
            Whether you&apos;re a member, a sponsor, a media partner, or someone who just wants to know more about HCAF - we&apos;d love to hear from you.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            <a
              href="mailto:hello@hoyichoyianondo.com"
              className="bg-dark-card border border-accent/15 rounded-2xl md:rounded-3xl p-5 md:p-6 hover:border-accent/40 hover:shadow-gold transition-all duration-300 group"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-accent/15 flex items-center justify-center text-accent mx-auto mb-3 group-hover:bg-accent/25 transition-colors">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </div>
              <p className="text-white/50 text-xs font-bold tracking-widest uppercase mb-1">Email</p>
              <p className="text-white font-semibold text-sm">hello@hoyichoyianondo.com</p>
            </a>

            <a
              href="https://instagram.com/HOYICHOYI"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-dark-card border border-accent/15 rounded-2xl md:rounded-3xl p-5 md:p-6 hover:border-accent/40 hover:shadow-gold transition-all duration-300 group"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-accent/15 flex items-center justify-center text-accent mx-auto mb-3 group-hover:bg-accent/25 transition-colors">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                </svg>
              </div>
              <p className="text-white/50 text-xs font-bold tracking-widest uppercase mb-1">Instagram</p>
              <p className="text-white font-semibold text-sm">@HOYICHOYI</p>
            </a>

            <a
              href="https://facebook.com/HOYICHOYI"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-dark-card border border-accent/15 rounded-2xl md:rounded-3xl p-5 md:p-6 hover:border-accent/40 hover:shadow-gold transition-all duration-300 group"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-accent/15 flex items-center justify-center text-accent mx-auto mb-3 group-hover:bg-accent/25 transition-colors">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </div>
              <p className="text-white/50 text-xs font-bold tracking-widest uppercase mb-1">Facebook</p>
              <p className="text-white font-semibold text-sm">@HOYICHOYI</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}